import { TemplateMediaType, TemplateMediaContent } from '@zeus/shared';
import { memo, useRef, useEffect } from 'react';

interface MediaProps {
  media: TemplateMediaContent;
  height?: number | string;
  borderRadius?: string;
  playing?: boolean;
  shouldLoad?: boolean;
  isDevelopment?: boolean;
}

const Media = ({
  media,
  height = '100%',
  borderRadius = '30px',
  playing = true,
  shouldLoad = true,
  isDevelopment = false,
}: MediaProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (playing && videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    } else if (!playing && videoRef.current) {
      videoRef.current.pause();
    }
  }, [playing]);

  // Don't render anything if it shouldn't be loaded - completely skip rendering
  if (!shouldLoad) {
    return null;
  }

  return (
    <>
      {media?.type === TemplateMediaType.Image && (
        <img
          src={media?.url}
          alt={'template media'}
          style={{
            objectFit: 'cover',
            borderRadius: borderRadius,
            width: '100%',
            height: height,
          }}
        />
      )}
      {media?.type === TemplateMediaType.Video && (
        <video
          ref={videoRef}
          src={media?.url}
          autoPlay={isDevelopment}
          preload="auto"
          muted
          loop={true}
          controls={false}
          playsInline
          style={{
            borderRadius: borderRadius,
            height: height,
            width: '100%',
            objectFit: 'cover',
          }}
        />
      )}
    </>
  );
};

export default memo(Media);
